import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import { rem } from 'polished'
import variables, { containerLarge } from 'styles/vendor/bootstrap/variables'

export type LayoutContainerSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * @deprecated size is 'old' way to define layout sizes, this no longer matches design definitions
   */
  size?: LayoutContainerSizes
  /**
   * This controls the width of the container.
   * Use this instead of `size` as it better matches current pattersn
   * medium = 932px
   * large = 1172px
   * extraLarge = 2560px
   */
  variant?: 'medium' | 'large' | 'extraLarge'
  relative?: boolean
}

const Container = styled.div`
  padding-right: ${rem(variables.gutterWidth / 2)};
  padding-left: ${rem(variables.gutterWidth / 2)};
  margin-right: auto;
  margin-left: auto;
  width: 100%;

  &.relative {
    position: relative;
  }

  &.xs {
    max-width: ${rem(512)};
  }

  &.sm {
    max-width: ${rem(750)};
  }

  &.md {
    max-width: ${rem(990)};
  }

  &.lg {
    max-width: ${containerLarge};
  }

  &.xl {
    max-width: ${rem(1352)};
  }



  /* Variant variations are gutterless, better matching design usages */
  &.variant-large {
    max-width: ${rem(1172)};
  }

  &.variant-medium {
    max-width: ${rem(932)};
  }

  &.variant-extraLarge {
    max-width: ${rem(2560)};
  }
`

const LayoutContainer = React.forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  const { size = 'lg', className, variant, relative, ...rest } = props

  return <Container
    {...rest}
    ref={ref}
    className={clsx(
      className,
      !variant ? size : undefined,
      variant ? `variant-${variant}` : undefined,
      relative ? 'relative' : undefined,
    )}
  />
})

export default LayoutContainer
